export default "__VITE_ASSET__59d53d2e__$_?nuxt_component=async__"